<div [style.width.%]="porcentagemAtual"></div>
